import ErrorPage from "@/components/ErrorPage";

export default function ErrorView() {
  const [searchParams] = useSearchParams();
  const getSearchParam = (paramKey: string) => {
    const paramValue = searchParams.get(paramKey);
    return paramValue ? decodeURI(paramValue) : "";
  };
  const errorMessage = getSearchParam("errorMessage");
  const navigate = useNavigate();
  function handleGoBack() {
    navigate(-1);
  }
  return <ErrorPage errorMessage={errorMessage} refreshPage={() => handleGoBack()} />;
}
